import { HStack, VStack } from "@chakra-ui/react";
import React from "react";

import { AiInterviewerFragment } from "../../graphql";
import { useIsBHScreenRbacEnabled } from "../../hooks/useIsBHScreenRbacEnabled";
import { useIsScreenOrgAtsConnected } from "../../hooks/useIsScreenOrgAtsConnected";
import AiInterviewerSection from "./AiInterviewerSection";
import AiInterviewerSectionTitle from "./AiInterviewerSectionTitle";
import AiInterviewerSettingsContentSettings from "./AiInterviewerSettingsContentSettings";
import AiInterviewerSettingsInterviewSettings from "./AiInterviewerSettingsInterviewSettings";
import AiInterviewerStaticLinkSettings from "./AiInterviewerStaticLinkSettings";

interface AiInterviewerSettingsProps {
  aiInterviewer: AiInterviewerFragment;
  readOnly: boolean;
}

const AiInterviewerSettings: React.FC<AiInterviewerSettingsProps> = ({
  aiInterviewer,
  readOnly,
}) => {
  const isBHScreenRbacEnabled = useIsBHScreenRbacEnabled();
  const isAtsLess = !useIsScreenOrgAtsConnected();

  return (
    <VStack w="100%" spacing={6} alignItems="stretch" py="4">
      <HStack w="100%" spacing={4} alignItems="flex-start">
        <AiInterviewerSection w="376px" minW="376px" flexShrink={0}>
          <AiInterviewerSectionTitle title="Settings" />
          <AiInterviewerSettingsInterviewSettings
            aiInterviewer={aiInterviewer}
            readOnly={readOnly}
            isShareEnabled={isBHScreenRbacEnabled}
          />
        </AiInterviewerSection>
        <VStack flex="1" minW={0} spacing={6} alignItems="stretch">
          {isAtsLess && (
            <AiInterviewerSection>
              <AiInterviewerStaticLinkSettings
                aiInterviewer={aiInterviewer}
                readOnly={readOnly}
              />
            </AiInterviewerSection>
          )}
          <AiInterviewerSection>
            <AiInterviewerSectionTitle title="Content" />
            <AiInterviewerSettingsContentSettings
              aiInterviewer={aiInterviewer}
              readOnly={readOnly}
            />
          </AiInterviewerSection>
        </VStack>
      </HStack>
    </VStack>
  );
};

export default AiInterviewerSettings;
